(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        state.items = action.value;
        state.authorIsCurrentUser = action.value.findIndex((entry) => entry.authorIsCurrentUser) > -1;
        break;

      default:
        break;
    }
    return state;
  };

  window.swinger.app({
    type: 'ratings',
    component: 'ratings',
    reducer: reducer(),
  })
    .then((app) => {
      const state = app.store.getState();
      const url = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.ratings}/${state.id}`;

      window.swinger.ajax(url)
        .then((result) => {
          app.store.dispatch({
            type: 'UPDATE',
            value: result,
          });
        })
        .catch((e) => {
          if (e) {
            console.error(e);
          }
        });
    })
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/ratings/ratings.js